import { createClient } from "@supabase/supabase-js";
const supabaseUrl = "https://fryuosjqahyluuqrfryk.supabase.co";
const supabaseKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZyeXVvc2pxYWh5bHV1cXJmcnlrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mjg2NTA5OTAsImV4cCI6MjA0NDIyNjk5MH0.jKMqh1iIH4RlSE1EC6IXL8RZC127yk29AkIjD-BBPik";
const supabase = createClient(supabaseUrl, supabaseKey);

export default supabase;
